import { useWatch } from "react-hook-form";
import React, { useEffect, useState } from "react";
import useTranslation from "next-translate/useTranslation";
import RadioValidateController from "@components/FormControllers/controllers/RadioValidateController";

const PasswordValidation = ({ control }) => {
  const { t } = useTranslation();
  const newPassword = useWatch({ control, name: "password" });

  const [requirements, setRequirements] = useState({
    uppercase: false,
    lowercase: false,
    number: false,
    symbol: false,
    length: false,
  });

  useEffect(() => {
    const uppercase = newPassword && /[A-Z]/.test(newPassword);
    const lowercase = newPassword && /[a-z]/.test(newPassword);
    const number = newPassword && /\d/.test(newPassword);
    const length = newPassword && newPassword.length >= 8;
    const symbol = newPassword && /[$%#*&@]/.test(newPassword);

    setRequirements({
      uppercase,
      lowercase,
      number,
      length,
      symbol,
    });
  }, [newPassword]);

  return (
    <>
      <RadioValidateController
        control={control}
        name=""
        inputValue={requirements.uppercase}
        label={t("validation.password.uppercase")}
      />
      <RadioValidateController
        control={control}
        name=""
        inputValue={requirements.lowercase}
        label={t("validation.password.lowercase")}
      />
      <RadioValidateController
        control={control}
        name=""
        inputValue={requirements.number}
        label={t("validation.password.number")}
      />
      <RadioValidateController
        control={control}
        name=""
        inputValue={requirements.symbol}
        label={t("validation.password.symbol")}
      />
      <RadioValidateController
        control={control}
        name=""
        inputValue={requirements.length}
        label={t("validation.password.min")}
      />
    </>
  );
};

export default PasswordValidation;
